import {get, post} from '@/ulits/http'

// 获取系统推荐名称
export function getName(params) {
  return get('api/get-nick-name',params)
}

//更改昵称

export function undateName(params) {
  return post('api/update-nick-name',params)
}

// 首页数据
export function homeInfo(params) {
  return post('api/home',params)
}

//分类列表

export function category(params) {
  return post('api/category',params)
}

// 作品画廊
export function flower(params) {
  return post('api/art-gallery',params)
}

// 获取jssdk
export function getsign(params) {
  return post('api/wx/getWxOfficialAccountJsSdkConfig',params)
}

// 获取openId
export function getOpen(params) {
  return post('api/wechat/get-info-by-code',params)
}

//画廊点赞
export function lickgalley(params) {
  return post('api/like-gallery',params)
}